const searchForms = document.querySelectorAll(".f-search")

searchForms.forEach((form) => {
  const input = form.querySelector<HTMLElement>(".f-text input")

  input?.addEventListener("focus", () => {
    form.classList.add("--open")
  })
})

window.addEventListener("click", (e) => {
  if (!(e.target instanceof Element)) return
  if (!e.target.closest(".f-search")) {
    document.querySelectorAll<HTMLElement>(".f-search")?.forEach((form) => form.classList.remove("--open"))
  }
})
